<div class="flex w-full h-full flex-col items-center justify-center absolute top-0 left-0 z-999" [class.bg-white]="!transparent">
<!--  <img [ngSrc]="siteInfo()?.logo ? '/v1/site/logo?t=' + siteInfo().logo :  '/assets/images/logo/finexword-logo.svg'" alt="Logo" height="92" width="500">-->
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
